export function normalizeSearch(str) {
  if (!str) return "";
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}

export function filterEmails(emails, searchTerm) {
  if (!searchTerm) return emails;
  
  const normalizedSearch = normalizeSearch(searchTerm);
  
  return emails.filter((email) => {
    const subjectNorm = normalizeSearch(email.subject || "");
    const fromNorm = normalizeSearch(email.from || "");
    const bodyNorm = normalizeSearch(email.text || "");
    
    return (
      subjectNorm.includes(normalizedSearch) ||
      fromNorm.includes(normalizedSearch) ||
      bodyNorm.includes(normalizedSearch)
    );
  });
}

export function filterCategories(categories, searchTerm) {
  if (!searchTerm) return categories;
  
  const normalizedSearch = normalizeSearch(searchTerm);
  
  return categories
    .map((cat) => ({
      ...cat,
      emails: cat.emails.filter((email) => {
        const subjectNorm = normalizeSearch(email.subject || "");
        const fromNorm = normalizeSearch(email.from || "");
        return subjectNorm.includes(normalizedSearch) || fromNorm.includes(normalizedSearch);
      }),
    }))
    .filter((cat) => cat.emails.length > 0);
}
